import { sumBy } from 'lodash';
import { useMemo } from 'react';
import { PieChartsData } from '../types';

export const useTotalSum = (formattedData: PieChartsData[]) => {
  return useMemo(() => sumBy(formattedData, (p) => p.value), [formattedData]);
};
